export type PromoDiscount = {
  discount: number;
  discountType: 'percentage' | 'flat';
  active?: boolean;
};

function isUsablePromo(promo?: PromoDiscount | null): promo is PromoDiscount {
  if (!promo) return false;
  if (promo.active === false) return false;
  if (!Number.isFinite(promo.discount) || promo.discount <= 0) return false;
  return promo.discountType === 'percentage' || promo.discountType === 'flat';
}

/** Amount off `listPrice` for a single promo. Capped at the list price so the
 *  sale cannot go negative. Shopify may reject a flat code larger than the
 *  line instead of capping it. */
export function promoDiscountAmount(
  listPrice: number,
  promo?: PromoDiscount | null,
): number {
  if (!Number.isFinite(listPrice) || listPrice <= 0) return 0;
  if (!isUsablePromo(promo)) return 0;

  const amount =
    promo.discountType === 'percentage'
      ? listPrice * (promo.discount / 100)
      : promo.discount;

  if (!Number.isFinite(amount) || amount <= 0) return 0;
  return Math.min(amount, listPrice);
}

export function bestPromoDiscountAmount(
  listPrice: number,
  promos: PromoDiscount[] = [],
): number {
  let best = 0;
  for (const promo of promos) {
    const amount = promoDiscountAmount(listPrice, promo);
    if (amount > best) best = amount;
  }
  return best;
}

export function applyBestPromo(
  listPrice: number,
  promos: PromoDiscount[] = [],
): number {
  const discounted = listPrice - bestPromoDiscountAmount(listPrice, promos);
  return discounted < 0 ? 0 : discounted;
}
